import { useState } from "react";
import { api } from "../lib/api";
import PageHeader from "../components/PageHeader";
import ChatPanel from "../components/ChatPanel";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { Lock, Users } from "lucide-react";

const adminApiClient = async (method, path, body) => {
  const res = await api.request({ method, url: path, data: body });
  return res.data;
};

export default function Forum() {
  const [tab, setTab] = useState("bureau");
  const currentLabel = localStorage.getItem("aij_user_label") || "Administrateur";

  return (
    <div data-testid="forum-page">
      <PageHeader
        eyebrow="Espace de discussion"
        title="Forum"
        description="Échangez en temps réel avec les autres membres du bureau et avec les adhérents validés."
      />

      <Tabs value={tab} onValueChange={setTab} className="space-y-5">
        <TabsList className="bg-white border border-brand-border">
          <TabsTrigger value="bureau" data-testid="tab-forum-bureau" className="data-[state=active]:bg-brand-navy data-[state=active]:text-white">
            <Lock size={14} className="mr-2" /> Bureau (privé)
          </TabsTrigger>
          <TabsTrigger value="members" data-testid="tab-forum-members" className="data-[state=active]:bg-brand-orange data-[state=active]:text-white">
            <Users size={14} className="mr-2" /> Membres validés
          </TabsTrigger>
        </TabsList>

        <TabsContent value="bureau" className="space-y-2">
          <p className="text-sm text-gray-500">
            Canal réservé aux membres du bureau. Coordonnez vos projets et décisions en privé.
          </p>
          <ChatPanel
            channel="bureau"
            apiClient={adminApiClient}
            canDelete
            currentLabel={currentLabel}
            placeholder="Message privé au bureau…"
          />
        </TabsContent>

        <TabsContent value="members" className="space-y-2">
          <p className="text-sm text-gray-500">
            Canal partagé avec les adhérents validés. Vos messages s&apos;affichent avec la mention <em>Bureau</em>.
          </p>
          <ChatPanel
            channel="members"
            apiClient={adminApiClient}
            canDelete
            currentLabel={currentLabel}
            placeholder="Message visible par tous les membres validés…"
          />
        </TabsContent>
      </Tabs>
    </div>
  );
}
